import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'giveFeedback.header.title' }),
    description: translate({ id: 'giveFeedback.header.description' }),
  }))

  return api
}
